// eslint-disable-next-line import/no-unresolved
import { id } from 'date-fns/locale';
import { apiUrl } from '../../../utils/api';
import { apiBasePath } from '../../BasicUrl';


const SallerInfoData = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getSallerInfoApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.seller}`,
                method: "POST",
                body: data,

            }),
        }),
        getSallerLogoApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.sellerLogo}`,
                method: "POST",
                body: data,

            }),
        }),
        getFoodMenu: build.mutation({
            query: (data) => ({
                url: `${apiUrl.foodMenu}`,
                method: "POST",
                body: data,
            })
        }),
        getFoodUpdate: build.mutation({
            query: (data) => ({
                url: `${apiUrl.foodUpdate}`,
                method: "POST",
                body: data,
            })
        }),
        getFoodSearch: build.mutation({
            query: (data) => ({
                url: `${apiUrl.foodSearch}`,
                method: "POST",
                body: data,
            })
        }),
        getFoodDeleteApi: build.mutation({
            query: ({ seller_id, food_id }) => ({
                url: `${apiUrl.foodDelete}?food_id=${food_id}&seller_id=${seller_id}`,
                method: "DELETE",
                // body: data,
            })
        }),

        getStoreImgApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.sallerShopPhoto}`,
                method: "POST",
                body: data,
            })
        }),

        getFoodDetails: build.query({
            query: (id) => ({
                url: `${apiUrl.foodDetails}?food=${id}`,
                method: "GET",

            }),
        }),
        // getFoodDetails: build.query({
        //     query: (id) => ({
        //         url: `${apiUrl.foodDetails}?food=${id}`,
        //         // method: "GET",
        //     })
        // }),

        getFoodActiveApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.foodActivate}`,
                method: "POST",
                body: data,
            })
        }),
        getFoodVerifiedApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.foodApprove}`,
                method: "POST",
                body: data,
            })
        }),


    }),
    overrideExisting: false,
});
export const { useGetSallerInfoApiMutation, useGetSallerLogoApiMutation, useGetFoodMenuMutation, useGetFoodUpdateMutation, useGetFoodDeleteApiMutation, useGetFoodSearchMutation, useGetStoreImgApiMutation, useGetFoodDetailsQuery, useGetFoodActiveApiMutation, useGetFoodVerifiedApiMutation } = SallerInfoData;
